module.exports = __webpack_public_path__ + "static/spaceman-2-1a8254222abe8bf9b49a9318337df941.png";